const safeKey = (s) => encodeURIComponent(String(s));

export default function buildFilterEntryKeepField(fieldName, column = {}, parentId = '') {

    // Cria valores padrões para query param e localStorage
    const baseSafe = safeKey(fieldName);
    const queryParamBase = `${baseSafe}`;
    const localKeyBase = `pf_${baseSafe}`;

    // Verifica se foi passado um 'parentId', que seria o formulario chamado, ao clicar em registro.
    const queryParam = parentId ? `${queryParamBase}_${parentId}` : queryParamBase;
    const localKey = parentId ? `${localKeyBase}_${parentId}` : localKeyBase;

    const typeOfField = column.fieldtype;

    const listText = ['Text', 'Numeric', 'refLookup', 'formula', 'label', 'Date', 'Time'];
    const listArray = ['multipleSelection', 'refMultipleSelection', 'uniqueSelection', 'refUniqueSelection']

    let type = '';
    if (listArray.includes(typeOfField)) type = 'array';
    else type = 'text';


    // cria o retorno para os filtros persistentes
    const entry = {
        field: fieldName,
        type,
        queryParam,
        localKey,
    };


    const vt = (column.valueType || '').toString().toLowerCase();

    // Campo do tipo Tempo: persistido como "HH:mm" (o ProTable com
    // dateFormatter="number" entrega timestamp em ms, que precisa ser
    // convertido antes de ir para a query/localStorage)
    if (typeOfField === 'Time' || vt === 'time') {
        entry.type = 'time';
    }

    // Se for um tipo data, com inicio e fim, passa os parametros de inicio e final para a query params / localStorage
    if (vt.includes('daterange') || vt.includes('date')) {
        entry.type = 'dateRange';
        entry.queryParamStart = `${queryParam}_start`;
        entry.queryParamEnd = `${queryParam}_end`;
        entry.localKeyStart = `${localKey}_start`;
        entry.localKeyEnd = `${localKey}_end`;
    }

    return entry;
}